import { Language } from '../types/language';

const LANGUAGE_KEY = 'cortex-language-preference';

export function getLanguage(): Language {
  try {
    const saved = localStorage.getItem(LANGUAGE_KEY);
    if (saved) {
      return saved as Language;
    }
  } catch (e) {
    console.error('Failed to access localStorage for language:', e);
  }
  return 'en'; // Default to English
}

export function setLanguage(lang: Language): void {
  try {
    localStorage.setItem(LANGUAGE_KEY, lang);
  } catch (e) {
    console.error('Failed to save language to localStorage:', e);
  }
}
